/**
 * @generated SignedSource<<9f936d5b706683f2e6b6688fc5e492f2>>
 * @relayHash fba7d5d44acaacff5df5be390cf30b1f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 82cb47c5ffdff692d5f711cc53319e1f8285c458f96c07456619564b649b037d

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type onboarding_setShowRedactionChangeBoardingOnIssueViewAsEditorMutation$variables = {
  cloudId: string;
  show: boolean;
};
export type onboarding_setShowRedactionChangeBoardingOnIssueViewAsEditorMutation$data = {
  readonly jira: {
    readonly userPreferences: {
      readonly setShowRedactionChangeBoardingOnIssueViewAsEditor: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type onboarding_setShowRedactionChangeBoardingOnIssueViewAsEditorMutation = {
  response: onboarding_setShowRedactionChangeBoardingOnIssueViewAsEditorMutation$data;
  variables: onboarding_setShowRedactionChangeBoardingOnIssueViewAsEditorMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "show"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "JiraUserPreferencesMutation",
        "kind": "LinkedField",
        "name": "userPreferences",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "show",
                "variableName": "show"
              }
            ],
            "kind": "ScalarField",
            "name": "setShowRedactionChangeBoardingOnIssueViewAsEditor"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "onboarding_setShowRedactionChangeBoardingOnIssueViewAsEditorMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "onboarding_setShowRedactionChangeBoardingOnIssueViewAsEditorMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "82cb47c5ffdff692d5f711cc53319e1f8285c458f96c07456619564b649b037d",
    "metadata": {},
    "name": "onboarding_setShowRedactionChangeBoardingOnIssueViewAsEditorMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "20c7889c3fa251dcd753eb816216dbe8";

export default node;
